"use client";

import { c as _c } from "react/compiler-runtime";
import { cn } from "@/utils/cn";
import Link from "next/link";
import { ReactNode } from "react";
interface PromotionalCardBaseProps {
  icon: ReactNode;
  title: string;
  description: string;
  ctaText?: string;
  onClick?: () => void;
  href?: string;
  className?: string;
  iconColor?: string;
  isExternal?: boolean;
  children?: ReactNode;
}
export function PromotionalCardBase(t0) {
  const $ = _c(37);
  const {
    icon,
    title,
    description,
    ctaText,
    onClick,
    href,
    className,
    iconColor: t1,
    children,
    isExternal
  } = t0;
  const iconColor = t1 === undefined ? "text-primary-600" : t1;
  const external = isExternal ?? href?.startsWith("http");
  let t2;
  if ($[0] !== className) {
    t2 = cn("flex items-center gap-4 px-4 py-3", "bg-gray-50/80 rounded-lg", "border-l-2 border-primary-400", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== iconColor) {
    t3 = cn("w-8 h-8 flex items-center justify-center shrink-0", iconColor);
    $[2] = iconColor;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== icon || $[5] !== t3) {
    t4 = <div className={t3}>{icon}</div>;
    $[4] = icon;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== title) {
    t5 = <span className="text-sm font-medium text-gray-800">{title}</span>;
    $[7] = title;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span className="text-gray-400 mx-2">·</span>;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== description) {
    t7 = <span className="text-xs text-gray-500">{description}</span>;
    $[10] = description;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== children || $[13] !== t5 || $[14] !== t7) {
    t8 = <div className="flex-1 min-w-0">{t5}{t6}{t7}{children}</div>;
    $[12] = children;
    $[13] = t5;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== ctaText) {
    t9 = ctaText && <span className="text-xs font-medium text-primary-600 shrink-0 hidden sm:inline">{ctaText} →</span>;
    $[16] = ctaText;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t2 || $[19] !== t4 || $[20] !== t8 || $[21] !== t9) {
    t10 = <div className={t2}>{t4}{t8}{t9}</div>;
    $[18] = t2;
    $[19] = t4;
    $[20] = t8;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  const content = t10;
  if (href) {
    if (external) {
      let t11;
      if ($[23] !== content || $[24] !== href || $[25] !== onClick) {
        t11 = <a href={href} target="_blank" rel="noopener noreferrer" onClick={onClick} className="block w-full">{content}</a>;
        $[23] = content;
        $[24] = href;
        $[25] = onClick;
        $[26] = t11;
      } else {
        t11 = $[26];
      }
      return t11;
    }
    let t11;
    if ($[27] !== content || $[28] !== href || $[29] !== onClick) {
      t11 = <Link href={href} onClick={onClick} className="block w-full">{content}</Link>;
      $[27] = content;
      $[28] = href;
      $[29] = onClick;
      $[30] = t11;
    } else {
      t11 = $[30];
    }
    return t11;
  }
  let t11;
  if ($[31] !== onClick) {
    t11 = e => {
      if (e.key === "Enter" || e.key === " ") {
        onClick?.();
      }
    };
    $[31] = onClick;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  let t12;
  if ($[33] !== content || $[34] !== onClick || $[35] !== t11) {
    t12 = <div role="button" tabIndex={0} onClick={onClick} onKeyDown={t11} className="cursor-pointer w-full">{content}</div>;
    $[33] = content;
    $[34] = onClick;
    $[35] = t11;
    $[36] = t12;
  } else {
    t12 = $[36];
  }
  return t12;
}